import { render, staticRenderFns } from "./JdsTextField.vue?vue&type=template&id=49895a72&scoped=true&"
import script from "./JdsTextField.vue?vue&type=script&lang=ts&"
export * from "./JdsTextField.vue?vue&type=script&lang=ts&"
import style0 from "./JdsTextField.vue?vue&type=style&index=0&id=49895a72&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49895a72",
  null
  
)

export default component.exports